/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SupportImport } from './routes/support'
import { Route as StaffImport } from './routes/staff'
import { Route as ClientImport } from './routes/client'
import { Route as SupportStaffImport } from './routes/support/staff'
import { Route as SupportServicesImport } from './routes/support/services'
import { Route as SupportPayoutsImport } from './routes/support/payouts'
import { Route as SupportOrdersImport } from './routes/support/orders'
import { Route as StaffTgPreregisterImport } from './routes/staff/tg-preregister'
import { Route as StaffPreRegistrationRequiredImport } from './routes/staff/_pre-registration-required'
import { Route as StaffPostRegistrationRequiredImport } from './routes/staff/_post-registration-required'
import { Route as PaymentSuccessImport } from './routes/payment.success'
import { Route as ClientTgPreregisterImport } from './routes/client/tg-preregister'
import { Route as ClientPreRegistrationRequiredImport } from './routes/client/_pre-registration-required'
import { Route as ClientPostRegistrationRequiredImport } from './routes/client/_post-registration-required'
import { Route as StaffPreRegistrationRequiredPostRegisterImport } from './routes/staff/_pre-registration-required/post-register'
import { Route as StaffPostRegistrationRequiredInfoImport } from './routes/staff/_post-registration-required/info'
import { Route as StaffPostRegistrationRequiredConfirmationRequiredImport } from './routes/staff/_post-registration-required/_confirmation-required'
import { Route as ClientPreRegistrationRequiredPostRegisterImport } from './routes/client/_pre-registration-required/post-register'
import { Route as ClientPostRegistrationRequiredOrderPaymentImport } from './routes/client/_post-registration-required/order-payment'
import { Route as ClientPostRegistrationRequiredNewOrderImport } from './routes/client/_post-registration-required/new-order'
import { Route as ClientPostRegistrationRequiredInfoImport } from './routes/client/_post-registration-required/info'
import { Route as ClientPostRegistrationRequiredOrdersIndexImport } from './routes/client/_post-registration-required/orders/index'
import { Route as StaffPostRegistrationRequiredConfirmationRequiredTakeOrderImport } from './routes/staff/_post-registration-required/_confirmation-required/take-order'
import { Route as StaffPostRegistrationRequiredConfirmationRequiredBalanceImport } from './routes/staff/_post-registration-required/_confirmation-required/balance'
import { Route as ClientPostRegistrationRequiredOrdersIdImport } from './routes/client/_post-registration-required/orders/$id'
import { Route as StaffPostRegistrationRequiredConfirmationRequiredOrdersIndexImport } from './routes/staff/_post-registration-required/_confirmation-required/orders/index'
import { Route as StaffPostRegistrationRequiredConfirmationRequiredOrdersIdImport } from './routes/staff/_post-registration-required/_confirmation-required/orders/$id'

// Create Virtual Routes

const StaffPostRegistrationRequiredProfileLazyImport = createFileRoute(
  '/staff/_post-registration-required/profile',
)()
const ClientPostRegistrationRequiredProfileLazyImport = createFileRoute(
  '/client/_post-registration-required/profile',
)()

// Create/Update Routes

const SupportRoute = SupportImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRoute,
} as any)

const StaffRoute = StaffImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => rootRoute,
} as any)

const ClientRoute = ClientImport.update({
  id: '/client',
  path: '/client',
  getParentRoute: () => rootRoute,
} as any)

const SupportStaffRoute = SupportStaffImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => SupportRoute,
} as any).lazy(() => import('./routes/support/staff.lazy').then((d) => d.Route))

const SupportServicesRoute = SupportServicesImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => SupportRoute,
} as any).lazy(() =>
  import('./routes/support/services.lazy').then((d) => d.Route),
)

const SupportPayoutsRoute = SupportPayoutsImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => SupportRoute,
} as any).lazy(() =>
  import('./routes/support/payouts.lazy').then((d) => d.Route),
)

const SupportOrdersRoute = SupportOrdersImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => SupportRoute,
} as any).lazy(() =>
  import('./routes/support/orders.lazy').then((d) => d.Route),
)

const StaffTgPreregisterRoute = StaffTgPreregisterImport.update({
  id: '/tg-preregister',
  path: '/tg-preregister',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPreRegistrationRequiredRoute =
  StaffPreRegistrationRequiredImport.update({
    id: '/_pre-registration-required',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPostRegistrationRequiredRoute =
  StaffPostRegistrationRequiredImport.update({
    id: '/_post-registration-required',
    getParentRoute: () => StaffRoute,
  } as any)

const PaymentSuccessRoute = PaymentSuccessImport.update({
  id: '/payment/success',
  path: '/payment/success',
  getParentRoute: () => rootRoute,
} as any)

const ClientTgPreregisterRoute = ClientTgPreregisterImport.update({
  id: '/tg-preregister',
  path: '/tg-preregister',
  getParentRoute: () => ClientRoute,
} as any)

const ClientPreRegistrationRequiredRoute =
  ClientPreRegistrationRequiredImport.update({
    id: '/_pre-registration-required',
    getParentRoute: () => ClientRoute,
  } as any)

const ClientPostRegistrationRequiredRoute =
  ClientPostRegistrationRequiredImport.update({
    id: '/_post-registration-required',
    getParentRoute: () => ClientRoute,
  } as any)

const StaffPostRegistrationRequiredProfileLazyRoute =
  StaffPostRegistrationRequiredProfileLazyImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => StaffPostRegistrationRequiredRoute,
  } as any).lazy(() =>
    import('./routes/staff/_post-registration-required/profile.lazy').then(
      (d) => d.Route,
    ),
  )

const ClientPostRegistrationRequiredProfileLazyRoute =
  ClientPostRegistrationRequiredProfileLazyImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => ClientPostRegistrationRequiredRoute,
  } as any).lazy(() =>
    import('./routes/client/_post-registration-required/profile.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPreRegistrationRequiredPostRegisterRoute =
  StaffPreRegistrationRequiredPostRegisterImport.update({
    id: '/post-register',
    path: '/post-register',
    getParentRoute: () => StaffPreRegistrationRequiredRoute,
  } as any).lazy(() =>
    import('./routes/staff/_pre-registration-required/post-register.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPostRegistrationRequiredInfoRoute =
  StaffPostRegistrationRequiredInfoImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => StaffPostRegistrationRequiredRoute,
  } as any).lazy(() =>
    import('./routes/staff/_post-registration-required/info.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPostRegistrationRequiredConfirmationRequiredRoute =
  StaffPostRegistrationRequiredConfirmationRequiredImport.update({
    id: '/_confirmation-required',
    getParentRoute: () => StaffPostRegistrationRequiredRoute,
  } as any)

const ClientPreRegistrationRequiredPostRegisterRoute =
  ClientPreRegistrationRequiredPostRegisterImport.update({
    id: '/post-register',
    path: '/post-register',
    getParentRoute: () => ClientPreRegistrationRequiredRoute,
  } as any).lazy(() =>
    import(
      './routes/client/_pre-registration-required/post-register.lazy'
    ).then((d) => d.Route),
  )

const ClientPostRegistrationRequiredOrderPaymentRoute =
  ClientPostRegistrationRequiredOrderPaymentImport.update({
    id: '/order-payment',
    path: '/order-payment',
    getParentRoute: () => ClientPostRegistrationRequiredRoute,
  } as any).lazy(() =>
    import(
      './routes/client/_post-registration-required/order-payment.lazy'
    ).then((d) => d.Route),
  )

const ClientPostRegistrationRequiredNewOrderRoute =
  ClientPostRegistrationRequiredNewOrderImport.update({
    id: '/new-order',
    path: '/new-order',
    getParentRoute: () => ClientPostRegistrationRequiredRoute,
  } as any).lazy(() =>
    import('./routes/client/_post-registration-required/new-order.lazy').then(
      (d) => d.Route,
    ),
  )

const ClientPostRegistrationRequiredInfoRoute =
  ClientPostRegistrationRequiredInfoImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => ClientPostRegistrationRequiredRoute,
  } as any).lazy(() =>
    import('./routes/client/_post-registration-required/info.lazy').then(
      (d) => d.Route,
    ),
  )

const ClientPostRegistrationRequiredOrdersIndexRoute =
  ClientPostRegistrationRequiredOrdersIndexImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => ClientPostRegistrationRequiredRoute,
  } as any).lazy(() =>
    import(
      './routes/client/_post-registration-required/orders/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPostRegistrationRequiredConfirmationRequiredTakeOrderRoute =
  StaffPostRegistrationRequiredConfirmationRequiredTakeOrderImport.update({
    id: '/take-order',
    path: '/take-order',
    getParentRoute: () =>
      StaffPostRegistrationRequiredConfirmationRequiredRoute,
  } as any).lazy(() =>
    import(
      './routes/staff/_post-registration-required/_confirmation-required/take-order.lazy'
    ).then((d) => d.Route),
  )

const StaffPostRegistrationRequiredConfirmationRequiredBalanceRoute =
  StaffPostRegistrationRequiredConfirmationRequiredBalanceImport.update({
    id: '/balance',
    path: '/balance',
    getParentRoute: () =>
      StaffPostRegistrationRequiredConfirmationRequiredRoute,
  } as any).lazy(() =>
    import(
      './routes/staff/_post-registration-required/_confirmation-required/balance.lazy'
    ).then((d) => d.Route),
  )

const ClientPostRegistrationRequiredOrdersIdRoute =
  ClientPostRegistrationRequiredOrdersIdImport.update({
    id: '/orders/$id',
    path: '/orders/$id',
    getParentRoute: () => ClientPostRegistrationRequiredRoute,
  } as any).lazy(() =>
    import('./routes/client/_post-registration-required/orders/$id.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPostRegistrationRequiredConfirmationRequiredOrdersIndexRoute =
  StaffPostRegistrationRequiredConfirmationRequiredOrdersIndexImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () =>
      StaffPostRegistrationRequiredConfirmationRequiredRoute,
  } as any).lazy(() =>
    import(
      './routes/staff/_post-registration-required/_confirmation-required/orders/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPostRegistrationRequiredConfirmationRequiredOrdersIdRoute =
  StaffPostRegistrationRequiredConfirmationRequiredOrdersIdImport.update({
    id: '/orders/$id',
    path: '/orders/$id',
    getParentRoute: () =>
      StaffPostRegistrationRequiredConfirmationRequiredRoute,
  } as any).lazy(() =>
    import(
      './routes/staff/_post-registration-required/_confirmation-required/orders/$id.lazy'
    ).then((d) => d.Route),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/client': {
      id: '/client'
      path: '/client'
      fullPath: '/client'
      preLoaderRoute: typeof ClientImport
      parentRoute: typeof rootRoute
    }
    '/staff': {
      id: '/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof StaffImport
      parentRoute: typeof rootRoute
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportImport
      parentRoute: typeof rootRoute
    }
    '/client/_post-registration-required': {
      id: '/client/_post-registration-required'
      path: ''
      fullPath: '/client'
      preLoaderRoute: typeof ClientPostRegistrationRequiredImport
      parentRoute: typeof ClientImport
    }
    '/client/_pre-registration-required': {
      id: '/client/_pre-registration-required'
      path: ''
      fullPath: '/client'
      preLoaderRoute: typeof ClientPreRegistrationRequiredImport
      parentRoute: typeof ClientImport
    }
    '/client/tg-preregister': {
      id: '/client/tg-preregister'
      path: '/tg-preregister'
      fullPath: '/client/tg-preregister'
      preLoaderRoute: typeof ClientTgPreregisterImport
      parentRoute: typeof ClientImport
    }
    '/payment/success': {
      id: '/payment/success'
      path: '/payment/success'
      fullPath: '/payment/success'
      preLoaderRoute: typeof PaymentSuccessImport
      parentRoute: typeof rootRoute
    }
    '/staff/_post-registration-required': {
      id: '/staff/_post-registration-required'
      path: ''
      fullPath: '/staff'
      preLoaderRoute: typeof StaffPostRegistrationRequiredImport
      parentRoute: typeof StaffImport
    }
    '/staff/_pre-registration-required': {
      id: '/staff/_pre-registration-required'
      path: ''
      fullPath: '/staff'
      preLoaderRoute: typeof StaffPreRegistrationRequiredImport
      parentRoute: typeof StaffImport
    }
    '/staff/tg-preregister': {
      id: '/staff/tg-preregister'
      path: '/tg-preregister'
      fullPath: '/staff/tg-preregister'
      preLoaderRoute: typeof StaffTgPreregisterImport
      parentRoute: typeof StaffImport
    }
    '/support/orders': {
      id: '/support/orders'
      path: '/orders'
      fullPath: '/support/orders'
      preLoaderRoute: typeof SupportOrdersImport
      parentRoute: typeof SupportImport
    }
    '/support/payouts': {
      id: '/support/payouts'
      path: '/payouts'
      fullPath: '/support/payouts'
      preLoaderRoute: typeof SupportPayoutsImport
      parentRoute: typeof SupportImport
    }
    '/support/services': {
      id: '/support/services'
      path: '/services'
      fullPath: '/support/services'
      preLoaderRoute: typeof SupportServicesImport
      parentRoute: typeof SupportImport
    }
    '/support/staff': {
      id: '/support/staff'
      path: '/staff'
      fullPath: '/support/staff'
      preLoaderRoute: typeof SupportStaffImport
      parentRoute: typeof SupportImport
    }
    '/client/_post-registration-required/info': {
      id: '/client/_post-registration-required/info'
      path: '/info'
      fullPath: '/client/info'
      preLoaderRoute: typeof ClientPostRegistrationRequiredInfoImport
      parentRoute: typeof ClientPostRegistrationRequiredImport
    }
    '/client/_post-registration-required/new-order': {
      id: '/client/_post-registration-required/new-order'
      path: '/new-order'
      fullPath: '/client/new-order'
      preLoaderRoute: typeof ClientPostRegistrationRequiredNewOrderImport
      parentRoute: typeof ClientPostRegistrationRequiredImport
    }
    '/client/_post-registration-required/order-payment': {
      id: '/client/_post-registration-required/order-payment'
      path: '/order-payment'
      fullPath: '/client/order-payment'
      preLoaderRoute: typeof ClientPostRegistrationRequiredOrderPaymentImport
      parentRoute: typeof ClientPostRegistrationRequiredImport
    }
    '/client/_pre-registration-required/post-register': {
      id: '/client/_pre-registration-required/post-register'
      path: '/post-register'
      fullPath: '/client/post-register'
      preLoaderRoute: typeof ClientPreRegistrationRequiredPostRegisterImport
      parentRoute: typeof ClientPreRegistrationRequiredImport
    }
    '/staff/_post-registration-required/_confirmation-required': {
      id: '/staff/_post-registration-required/_confirmation-required'
      path: ''
      fullPath: '/staff'
      preLoaderRoute: typeof StaffPostRegistrationRequiredConfirmationRequiredImport
      parentRoute: typeof StaffPostRegistrationRequiredImport
    }
    '/staff/_post-registration-required/info': {
      id: '/staff/_post-registration-required/info'
      path: '/info'
      fullPath: '/staff/info'
      preLoaderRoute: typeof StaffPostRegistrationRequiredInfoImport
      parentRoute: typeof StaffPostRegistrationRequiredImport
    }
    '/staff/_pre-registration-required/post-register': {
      id: '/staff/_pre-registration-required/post-register'
      path: '/post-register'
      fullPath: '/staff/post-register'
      preLoaderRoute: typeof StaffPreRegistrationRequiredPostRegisterImport
      parentRoute: typeof StaffPreRegistrationRequiredImport
    }
    '/client/_post-registration-required/profile': {
      id: '/client/_post-registration-required/profile'
      path: '/profile'
      fullPath: '/client/profile'
      preLoaderRoute: typeof ClientPostRegistrationRequiredProfileLazyImport
      parentRoute: typeof ClientPostRegistrationRequiredImport
    }
    '/staff/_post-registration-required/profile': {
      id: '/staff/_post-registration-required/profile'
      path: '/profile'
      fullPath: '/staff/profile'
      preLoaderRoute: typeof StaffPostRegistrationRequiredProfileLazyImport
      parentRoute: typeof StaffPostRegistrationRequiredImport
    }
    '/client/_post-registration-required/orders/$id': {
      id: '/client/_post-registration-required/orders/$id'
      path: '/orders/$id'
      fullPath: '/client/orders/$id'
      preLoaderRoute: typeof ClientPostRegistrationRequiredOrdersIdImport
      parentRoute: typeof ClientPostRegistrationRequiredImport
    }
    '/staff/_post-registration-required/_confirmation-required/balance': {
      id: '/staff/_post-registration-required/_confirmation-required/balance'
      path: '/balance'
      fullPath: '/staff/balance'
      preLoaderRoute: typeof StaffPostRegistrationRequiredConfirmationRequiredBalanceImport
      parentRoute: typeof StaffPostRegistrationRequiredConfirmationRequiredImport
    }
    '/staff/_post-registration-required/_confirmation-required/take-order': {
      id: '/staff/_post-registration-required/_confirmation-required/take-order'
      path: '/take-order'
      fullPath: '/staff/take-order'
      preLoaderRoute: typeof StaffPostRegistrationRequiredConfirmationRequiredTakeOrderImport
      parentRoute: typeof StaffPostRegistrationRequiredConfirmationRequiredImport
    }
    '/client/_post-registration-required/orders/': {
      id: '/client/_post-registration-required/orders/'
      path: '/orders'
      fullPath: '/client/orders'
      preLoaderRoute: typeof ClientPostRegistrationRequiredOrdersIndexImport
      parentRoute: typeof ClientPostRegistrationRequiredImport
    }
    '/staff/_post-registration-required/_confirmation-required/orders/$id': {
      id: '/staff/_post-registration-required/_confirmation-required/orders/$id'
      path: '/orders/$id'
      fullPath: '/staff/orders/$id'
      preLoaderRoute: typeof StaffPostRegistrationRequiredConfirmationRequiredOrdersIdImport
      parentRoute: typeof StaffPostRegistrationRequiredConfirmationRequiredImport
    }
    '/staff/_post-registration-required/_confirmation-required/orders/': {
      id: '/staff/_post-registration-required/_confirmation-required/orders/'
      path: '/orders'
      fullPath: '/staff/orders'
      preLoaderRoute: typeof StaffPostRegistrationRequiredConfirmationRequiredOrdersIndexImport
      parentRoute: typeof StaffPostRegistrationRequiredConfirmationRequiredImport
    }
  }
}

// Create and export the route tree

interface ClientPostRegistrationRequiredRouteChildren {
  ClientPostRegistrationRequiredInfoRoute: typeof ClientPostRegistrationRequiredInfoRoute
  ClientPostRegistrationRequiredNewOrderRoute: typeof ClientPostRegistrationRequiredNewOrderRoute
  ClientPostRegistrationRequiredOrderPaymentRoute: typeof ClientPostRegistrationRequiredOrderPaymentRoute
  ClientPostRegistrationRequiredProfileLazyRoute: typeof ClientPostRegistrationRequiredProfileLazyRoute
  ClientPostRegistrationRequiredOrdersIdRoute: typeof ClientPostRegistrationRequiredOrdersIdRoute
  ClientPostRegistrationRequiredOrdersIndexRoute: typeof ClientPostRegistrationRequiredOrdersIndexRoute
}

const ClientPostRegistrationRequiredRouteChildren: ClientPostRegistrationRequiredRouteChildren =
  {
    ClientPostRegistrationRequiredInfoRoute:
      ClientPostRegistrationRequiredInfoRoute,
    ClientPostRegistrationRequiredNewOrderRoute:
      ClientPostRegistrationRequiredNewOrderRoute,
    ClientPostRegistrationRequiredOrderPaymentRoute:
      ClientPostRegistrationRequiredOrderPaymentRoute,
    ClientPostRegistrationRequiredProfileLazyRoute:
      ClientPostRegistrationRequiredProfileLazyRoute,
    ClientPostRegistrationRequiredOrdersIdRoute:
      ClientPostRegistrationRequiredOrdersIdRoute,
    ClientPostRegistrationRequiredOrdersIndexRoute:
      ClientPostRegistrationRequiredOrdersIndexRoute,
  }

const ClientPostRegistrationRequiredRouteWithChildren =
  ClientPostRegistrationRequiredRoute._addFileChildren(
    ClientPostRegistrationRequiredRouteChildren,
  )

interface ClientPreRegistrationRequiredRouteChildren {
  ClientPreRegistrationRequiredPostRegisterRoute: typeof ClientPreRegistrationRequiredPostRegisterRoute
}

const ClientPreRegistrationRequiredRouteChildren: ClientPreRegistrationRequiredRouteChildren =
  {
    ClientPreRegistrationRequiredPostRegisterRoute:
      ClientPreRegistrationRequiredPostRegisterRoute,
  }

const ClientPreRegistrationRequiredRouteWithChildren =
  ClientPreRegistrationRequiredRoute._addFileChildren(
    ClientPreRegistrationRequiredRouteChildren,
  )

interface ClientRouteChildren {
  ClientPostRegistrationRequiredRoute: typeof ClientPostRegistrationRequiredRouteWithChildren
  ClientPreRegistrationRequiredRoute: typeof ClientPreRegistrationRequiredRouteWithChildren
  ClientTgPreregisterRoute: typeof ClientTgPreregisterRoute
}

const ClientRouteChildren: ClientRouteChildren = {
  ClientPostRegistrationRequiredRoute:
    ClientPostRegistrationRequiredRouteWithChildren,
  ClientPreRegistrationRequiredRoute:
    ClientPreRegistrationRequiredRouteWithChildren,
  ClientTgPreregisterRoute: ClientTgPreregisterRoute,
}

const ClientRouteWithChildren =
  ClientRoute._addFileChildren(ClientRouteChildren)

interface StaffPostRegistrationRequiredConfirmationRequiredRouteChildren {
  StaffPostRegistrationRequiredConfirmationRequiredBalanceRoute: typeof StaffPostRegistrationRequiredConfirmationRequiredBalanceRoute
  StaffPostRegistrationRequiredConfirmationRequiredTakeOrderRoute: typeof StaffPostRegistrationRequiredConfirmationRequiredTakeOrderRoute
  StaffPostRegistrationRequiredConfirmationRequiredOrdersIdRoute: typeof StaffPostRegistrationRequiredConfirmationRequiredOrdersIdRoute
  StaffPostRegistrationRequiredConfirmationRequiredOrdersIndexRoute: typeof StaffPostRegistrationRequiredConfirmationRequiredOrdersIndexRoute
}

const StaffPostRegistrationRequiredConfirmationRequiredRouteChildren: StaffPostRegistrationRequiredConfirmationRequiredRouteChildren =
  {
    StaffPostRegistrationRequiredConfirmationRequiredBalanceRoute:
      StaffPostRegistrationRequiredConfirmationRequiredBalanceRoute,
    StaffPostRegistrationRequiredConfirmationRequiredTakeOrderRoute:
      StaffPostRegistrationRequiredConfirmationRequiredTakeOrderRoute,
    StaffPostRegistrationRequiredConfirmationRequiredOrdersIdRoute:
      StaffPostRegistrationRequiredConfirmationRequiredOrdersIdRoute,
    StaffPostRegistrationRequiredConfirmationRequiredOrdersIndexRoute:
      StaffPostRegistrationRequiredConfirmationRequiredOrdersIndexRoute,
  }

const StaffPostRegistrationRequiredConfirmationRequiredRouteWithChildren =
  StaffPostRegistrationRequiredConfirmationRequiredRoute._addFileChildren(
    StaffPostRegistrationRequiredConfirmationRequiredRouteChildren,
  )

interface StaffPostRegistrationRequiredRouteChildren {
  StaffPostRegistrationRequiredConfirmationRequiredRoute: typeof StaffPostRegistrationRequiredConfirmationRequiredRouteWithChildren
  StaffPostRegistrationRequiredInfoRoute: typeof StaffPostRegistrationRequiredInfoRoute
  StaffPostRegistrationRequiredProfileLazyRoute: typeof StaffPostRegistrationRequiredProfileLazyRoute
}

const StaffPostRegistrationRequiredRouteChildren: StaffPostRegistrationRequiredRouteChildren =
  {
    StaffPostRegistrationRequiredConfirmationRequiredRoute:
      StaffPostRegistrationRequiredConfirmationRequiredRouteWithChildren,
    StaffPostRegistrationRequiredInfoRoute:
      StaffPostRegistrationRequiredInfoRoute,
    StaffPostRegistrationRequiredProfileLazyRoute:
      StaffPostRegistrationRequiredProfileLazyRoute,
  }

const StaffPostRegistrationRequiredRouteWithChildren =
  StaffPostRegistrationRequiredRoute._addFileChildren(
    StaffPostRegistrationRequiredRouteChildren,
  )

interface StaffPreRegistrationRequiredRouteChildren {
  StaffPreRegistrationRequiredPostRegisterRoute: typeof StaffPreRegistrationRequiredPostRegisterRoute
}

const StaffPreRegistrationRequiredRouteChildren: StaffPreRegistrationRequiredRouteChildren =
  {
    StaffPreRegistrationRequiredPostRegisterRoute:
      StaffPreRegistrationRequiredPostRegisterRoute,
  }

const StaffPreRegistrationRequiredRouteWithChildren =
  StaffPreRegistrationRequiredRoute._addFileChildren(
    StaffPreRegistrationRequiredRouteChildren,
  )

interface StaffRouteChildren {
  StaffPostRegistrationRequiredRoute: typeof StaffPostRegistrationRequiredRouteWithChildren
  StaffPreRegistrationRequiredRoute: typeof StaffPreRegistrationRequiredRouteWithChildren
  StaffTgPreregisterRoute: typeof StaffTgPreregisterRoute
}

const StaffRouteChildren: StaffRouteChildren = {
  StaffPostRegistrationRequiredRoute:
    StaffPostRegistrationRequiredRouteWithChildren,
  StaffPreRegistrationRequiredRoute:
    StaffPreRegistrationRequiredRouteWithChildren,
  StaffTgPreregisterRoute: StaffTgPreregisterRoute,
}

const StaffRouteWithChildren = StaffRoute._addFileChildren(StaffRouteChildren)

interface SupportRouteChildren {
  SupportOrdersRoute: typeof SupportOrdersRoute
  SupportPayoutsRoute: typeof SupportPayoutsRoute
  SupportServicesRoute: typeof SupportServicesRoute
  SupportStaffRoute: typeof SupportStaffRoute
}

const SupportRouteChildren: SupportRouteChildren = {
  SupportOrdersRoute: SupportOrdersRoute,
  SupportPayoutsRoute: SupportPayoutsRoute,
  SupportServicesRoute: SupportServicesRoute,
  SupportStaffRoute: SupportStaffRoute,
}

const SupportRouteWithChildren =
  SupportRoute._addFileChildren(SupportRouteChildren)

export interface FileRoutesByFullPath {
  '/client': typeof ClientPreRegistrationRequiredRouteWithChildren
  '/staff': typeof StaffPostRegistrationRequiredConfirmationRequiredRouteWithChildren
  '/support': typeof SupportRouteWithChildren
  '/client/tg-preregister': typeof ClientTgPreregisterRoute
  '/payment/success': typeof PaymentSuccessRoute
  '/staff/tg-preregister': typeof StaffTgPreregisterRoute
  '/support/orders': typeof SupportOrdersRoute
  '/support/payouts': typeof SupportPayoutsRoute
  '/support/services': typeof SupportServicesRoute
  '/support/staff': typeof SupportStaffRoute
  '/client/info': typeof ClientPostRegistrationRequiredInfoRoute
  '/client/new-order': typeof ClientPostRegistrationRequiredNewOrderRoute
  '/client/order-payment': typeof ClientPostRegistrationRequiredOrderPaymentRoute
  '/client/post-register': typeof ClientPreRegistrationRequiredPostRegisterRoute
  '/staff/info': typeof StaffPostRegistrationRequiredInfoRoute
  '/staff/post-register': typeof StaffPreRegistrationRequiredPostRegisterRoute
  '/client/profile': typeof ClientPostRegistrationRequiredProfileLazyRoute
  '/staff/profile': typeof StaffPostRegistrationRequiredProfileLazyRoute
  '/client/orders/$id': typeof ClientPostRegistrationRequiredOrdersIdRoute
  '/staff/balance': typeof StaffPostRegistrationRequiredConfirmationRequiredBalanceRoute
  '/staff/take-order': typeof StaffPostRegistrationRequiredConfirmationRequiredTakeOrderRoute
  '/client/orders': typeof ClientPostRegistrationRequiredOrdersIndexRoute
  '/staff/orders/$id': typeof StaffPostRegistrationRequiredConfirmationRequiredOrdersIdRoute
  '/staff/orders': typeof StaffPostRegistrationRequiredConfirmationRequiredOrdersIndexRoute
}

export interface FileRoutesByTo {
  '/client': typeof ClientPreRegistrationRequiredRouteWithChildren
  '/staff': typeof StaffPostRegistrationRequiredConfirmationRequiredRouteWithChildren
  '/support': typeof SupportRouteWithChildren
  '/client/tg-preregister': typeof ClientTgPreregisterRoute
  '/payment/success': typeof PaymentSuccessRoute
  '/staff/tg-preregister': typeof StaffTgPreregisterRoute
  '/support/orders': typeof SupportOrdersRoute
  '/support/payouts': typeof SupportPayoutsRoute
  '/support/services': typeof SupportServicesRoute
  '/support/staff': typeof SupportStaffRoute
  '/client/info': typeof ClientPostRegistrationRequiredInfoRoute
  '/client/new-order': typeof ClientPostRegistrationRequiredNewOrderRoute
  '/client/order-payment': typeof ClientPostRegistrationRequiredOrderPaymentRoute
  '/client/post-register': typeof ClientPreRegistrationRequiredPostRegisterRoute
  '/staff/info': typeof StaffPostRegistrationRequiredInfoRoute
  '/staff/post-register': typeof StaffPreRegistrationRequiredPostRegisterRoute
  '/client/profile': typeof ClientPostRegistrationRequiredProfileLazyRoute
  '/staff/profile': typeof StaffPostRegistrationRequiredProfileLazyRoute
  '/client/orders/$id': typeof ClientPostRegistrationRequiredOrdersIdRoute
  '/staff/balance': typeof StaffPostRegistrationRequiredConfirmationRequiredBalanceRoute
  '/staff/take-order': typeof StaffPostRegistrationRequiredConfirmationRequiredTakeOrderRoute
  '/client/orders': typeof ClientPostRegistrationRequiredOrdersIndexRoute
  '/staff/orders/$id': typeof StaffPostRegistrationRequiredConfirmationRequiredOrdersIdRoute
  '/staff/orders': typeof StaffPostRegistrationRequiredConfirmationRequiredOrdersIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/client': typeof ClientRouteWithChildren
  '/staff': typeof StaffRouteWithChildren
  '/support': typeof SupportRouteWithChildren
  '/client/_post-registration-required': typeof ClientPostRegistrationRequiredRouteWithChildren
  '/client/_pre-registration-required': typeof ClientPreRegistrationRequiredRouteWithChildren
  '/client/tg-preregister': typeof ClientTgPreregisterRoute
  '/payment/success': typeof PaymentSuccessRoute
  '/staff/_post-registration-required': typeof StaffPostRegistrationRequiredRouteWithChildren
  '/staff/_pre-registration-required': typeof StaffPreRegistrationRequiredRouteWithChildren
  '/staff/tg-preregister': typeof StaffTgPreregisterRoute
  '/support/orders': typeof SupportOrdersRoute
  '/support/payouts': typeof SupportPayoutsRoute
  '/support/services': typeof SupportServicesRoute
  '/support/staff': typeof SupportStaffRoute
  '/client/_post-registration-required/info': typeof ClientPostRegistrationRequiredInfoRoute
  '/client/_post-registration-required/new-order': typeof ClientPostRegistrationRequiredNewOrderRoute
  '/client/_post-registration-required/order-payment': typeof ClientPostRegistrationRequiredOrderPaymentRoute
  '/client/_pre-registration-required/post-register': typeof ClientPreRegistrationRequiredPostRegisterRoute
  '/staff/_post-registration-required/_confirmation-required': typeof StaffPostRegistrationRequiredConfirmationRequiredRouteWithChildren
  '/staff/_post-registration-required/info': typeof StaffPostRegistrationRequiredInfoRoute
  '/staff/_pre-registration-required/post-register': typeof StaffPreRegistrationRequiredPostRegisterRoute
  '/client/_post-registration-required/profile': typeof ClientPostRegistrationRequiredProfileLazyRoute
  '/staff/_post-registration-required/profile': typeof StaffPostRegistrationRequiredProfileLazyRoute
  '/client/_post-registration-required/orders/$id': typeof ClientPostRegistrationRequiredOrdersIdRoute
  '/staff/_post-registration-required/_confirmation-required/balance': typeof StaffPostRegistrationRequiredConfirmationRequiredBalanceRoute
  '/staff/_post-registration-required/_confirmation-required/take-order': typeof StaffPostRegistrationRequiredConfirmationRequiredTakeOrderRoute
  '/client/_post-registration-required/orders/': typeof ClientPostRegistrationRequiredOrdersIndexRoute
  '/staff/_post-registration-required/_confirmation-required/orders/$id': typeof StaffPostRegistrationRequiredConfirmationRequiredOrdersIdRoute
  '/staff/_post-registration-required/_confirmation-required/orders/': typeof StaffPostRegistrationRequiredConfirmationRequiredOrdersIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/client'
    | '/staff'
    | '/support'
    | '/client/tg-preregister'
    | '/payment/success'
    | '/staff/tg-preregister'
    | '/support/orders'
    | '/support/payouts'
    | '/support/services'
    | '/support/staff'
    | '/client/info'
    | '/client/new-order'
    | '/client/order-payment'
    | '/client/post-register'
    | '/staff/info'
    | '/staff/post-register'
    | '/client/profile'
    | '/staff/profile'
    | '/client/orders/$id'
    | '/staff/balance'
    | '/staff/take-order'
    | '/client/orders'
    | '/staff/orders/$id'
    | '/staff/orders'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/client'
    | '/staff'
    | '/support'
    | '/client/tg-preregister'
    | '/payment/success'
    | '/staff/tg-preregister'
    | '/support/orders'
    | '/support/payouts'
    | '/support/services'
    | '/support/staff'
    | '/client/info'
    | '/client/new-order'
    | '/client/order-payment'
    | '/client/post-register'
    | '/staff/info'
    | '/staff/post-register'
    | '/client/profile'
    | '/staff/profile'
    | '/client/orders/$id'
    | '/staff/balance'
    | '/staff/take-order'
    | '/client/orders'
    | '/staff/orders/$id'
    | '/staff/orders'
  id:
    | '__root__'
    | '/client'
    | '/staff'
    | '/support'
    | '/client/_post-registration-required'
    | '/client/_pre-registration-required'
    | '/client/tg-preregister'
    | '/payment/success'
    | '/staff/_post-registration-required'
    | '/staff/_pre-registration-required'
    | '/staff/tg-preregister'
    | '/support/orders'
    | '/support/payouts'
    | '/support/services'
    | '/support/staff'
    | '/client/_post-registration-required/info'
    | '/client/_post-registration-required/new-order'
    | '/client/_post-registration-required/order-payment'
    | '/client/_pre-registration-required/post-register'
    | '/staff/_post-registration-required/_confirmation-required'
    | '/staff/_post-registration-required/info'
    | '/staff/_pre-registration-required/post-register'
    | '/client/_post-registration-required/profile'
    | '/staff/_post-registration-required/profile'
    | '/client/_post-registration-required/orders/$id'
    | '/staff/_post-registration-required/_confirmation-required/balance'
    | '/staff/_post-registration-required/_confirmation-required/take-order'
    | '/client/_post-registration-required/orders/'
    | '/staff/_post-registration-required/_confirmation-required/orders/$id'
    | '/staff/_post-registration-required/_confirmation-required/orders/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  ClientRoute: typeof ClientRouteWithChildren
  StaffRoute: typeof StaffRouteWithChildren
  SupportRoute: typeof SupportRouteWithChildren
  PaymentSuccessRoute: typeof PaymentSuccessRoute
}

const rootRouteChildren: RootRouteChildren = {
  ClientRoute: ClientRouteWithChildren,
  StaffRoute: StaffRouteWithChildren,
  SupportRoute: SupportRouteWithChildren,
  PaymentSuccessRoute: PaymentSuccessRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/client",
        "/staff",
        "/support",
        "/payment/success"
      ]
    },
    "/client": {
      "filePath": "client.tsx",
      "children": [
        "/client/_post-registration-required",
        "/client/_pre-registration-required",
        "/client/tg-preregister"
      ]
    },
    "/staff": {
      "filePath": "staff.tsx",
      "children": [
        "/staff/_post-registration-required",
        "/staff/_pre-registration-required",
        "/staff/tg-preregister"
      ]
    },
    "/support": {
      "filePath": "support.tsx",
      "children": [
        "/support/orders",
        "/support/payouts",
        "/support/services",
        "/support/staff"
      ]
    },
    "/client/_post-registration-required": {
      "filePath": "client/_post-registration-required.tsx",
      "parent": "/client",
      "children": [
        "/client/_post-registration-required/info",
        "/client/_post-registration-required/new-order",
        "/client/_post-registration-required/order-payment",
        "/client/_post-registration-required/profile",
        "/client/_post-registration-required/orders/$id",
        "/client/_post-registration-required/orders/"
      ]
    },
    "/client/_pre-registration-required": {
      "filePath": "client/_pre-registration-required.tsx",
      "parent": "/client",
      "children": [
        "/client/_pre-registration-required/post-register"
      ]
    },
    "/client/tg-preregister": {
      "filePath": "client/tg-preregister.tsx",
      "parent": "/client"
    },
    "/payment/success": {
      "filePath": "payment.success.tsx"
    },
    "/staff/_post-registration-required": {
      "filePath": "staff/_post-registration-required.tsx",
      "parent": "/staff",
      "children": [
        "/staff/_post-registration-required/_confirmation-required",
        "/staff/_post-registration-required/info",
        "/staff/_post-registration-required/profile"
      ]
    },
    "/staff/_pre-registration-required": {
      "filePath": "staff/_pre-registration-required.tsx",
      "parent": "/staff",
      "children": [
        "/staff/_pre-registration-required/post-register"
      ]
    },
    "/staff/tg-preregister": {
      "filePath": "staff/tg-preregister.tsx",
      "parent": "/staff"
    },
    "/support/orders": {
      "filePath": "support/orders.tsx",
      "parent": "/support"
    },
    "/support/payouts": {
      "filePath": "support/payouts.tsx",
      "parent": "/support"
    },
    "/support/services": {
      "filePath": "support/services.tsx",
      "parent": "/support"
    },
    "/support/staff": {
      "filePath": "support/staff.tsx",
      "parent": "/support"
    },
    "/client/_post-registration-required/info": {
      "filePath": "client/_post-registration-required/info.tsx",
      "parent": "/client/_post-registration-required"
    },
    "/client/_post-registration-required/new-order": {
      "filePath": "client/_post-registration-required/new-order.tsx",
      "parent": "/client/_post-registration-required"
    },
    "/client/_post-registration-required/order-payment": {
      "filePath": "client/_post-registration-required/order-payment.tsx",
      "parent": "/client/_post-registration-required"
    },
    "/client/_pre-registration-required/post-register": {
      "filePath": "client/_pre-registration-required/post-register.tsx",
      "parent": "/client/_pre-registration-required"
    },
    "/staff/_post-registration-required/_confirmation-required": {
      "filePath": "staff/_post-registration-required/_confirmation-required.tsx",
      "parent": "/staff/_post-registration-required",
      "children": [
        "/staff/_post-registration-required/_confirmation-required/balance",
        "/staff/_post-registration-required/_confirmation-required/take-order",
        "/staff/_post-registration-required/_confirmation-required/orders/$id",
        "/staff/_post-registration-required/_confirmation-required/orders/"
      ]
    },
    "/staff/_post-registration-required/info": {
      "filePath": "staff/_post-registration-required/info.tsx",
      "parent": "/staff/_post-registration-required"
    },
    "/staff/_pre-registration-required/post-register": {
      "filePath": "staff/_pre-registration-required/post-register.tsx",
      "parent": "/staff/_pre-registration-required"
    },
    "/client/_post-registration-required/profile": {
      "filePath": "client/_post-registration-required/profile.lazy.tsx",
      "parent": "/client/_post-registration-required"
    },
    "/staff/_post-registration-required/profile": {
      "filePath": "staff/_post-registration-required/profile.lazy.tsx",
      "parent": "/staff/_post-registration-required"
    },
    "/client/_post-registration-required/orders/$id": {
      "filePath": "client/_post-registration-required/orders/$id.tsx",
      "parent": "/client/_post-registration-required"
    },
    "/staff/_post-registration-required/_confirmation-required/balance": {
      "filePath": "staff/_post-registration-required/_confirmation-required/balance.tsx",
      "parent": "/staff/_post-registration-required/_confirmation-required"
    },
    "/staff/_post-registration-required/_confirmation-required/take-order": {
      "filePath": "staff/_post-registration-required/_confirmation-required/take-order.tsx",
      "parent": "/staff/_post-registration-required/_confirmation-required"
    },
    "/client/_post-registration-required/orders/": {
      "filePath": "client/_post-registration-required/orders/index.tsx",
      "parent": "/client/_post-registration-required"
    },
    "/staff/_post-registration-required/_confirmation-required/orders/$id": {
      "filePath": "staff/_post-registration-required/_confirmation-required/orders/$id.tsx",
      "parent": "/staff/_post-registration-required/_confirmation-required"
    },
    "/staff/_post-registration-required/_confirmation-required/orders/": {
      "filePath": "staff/_post-registration-required/_confirmation-required/orders/index.tsx",
      "parent": "/staff/_post-registration-required/_confirmation-required"
    }
  }
}
ROUTE_MANIFEST_END */
